import React,{Component} from "react";

// reactstrap components
import {
  Col,
  Progress,
  Button,
  Input
} from "reactstrap";
import SpeechRecognition from 'react-speech-recognition';
import Dictaphone from "./Dictaphone.jsx";
import Sound from 'react-sound';
import {base,s3base} from "api.js";
import MicRecorder from 'mic-recorder-to-mp3';
// import getBlobDuration from 'get-blob-duration';
import { getBlobURL, getFile, getDuration } from "util/blobUtils.js";
import "components/custom.css";
import NoMicrophone from "views/NoMicrophone";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns.jsx";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";

let Mp3Recorder = new MicRecorder({ bitRate: 128 });

class ShortQue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      question:"",
      secondCount:3,
      secondCount2:1,
      duration:0,
      recordCount:0,
      recordId:1,
      intervalId:0,
      questionId:"",
      reset:false,
      soundStatus:true,
      soundPer:0,
      volume:100,
      trans:'',
      correctFlag:true,
      beepStatus:false,
      file:'',
      playbackSpeed: 1,
      soundKey: 0,
      secondCount2Bckup: 0,
      question_audio: null,
      defaultSelectedVoice: null,
      currentAudioIndex: null,
      audioRetryCount: 0,
      isProcessing: false,
    };
  }

 revokeBlobURL = () => {
    const { blobURL } = this.state;
    if (blobURL) {
      try {
        // Only revoke if URL exists and is a proper blob URL
        if (blobURL.startsWith("blob:")) {
          URL.revokeObjectURL(blobURL);
          console.log("🧹 Revoked blob URL instantly:", blobURL);
        }
      } catch (err) {
        console.error("⚠️ Failed to revoke blob URL:", err);
      } finally {
        // Clear from state to prevent reuse
        this.setState({ blobURL: '' });
      }
    }
  };
 
  componentDidMount() {
    if (!this.props.answer) {
      // select audio.
      // let question_audio = null;
      // let defaultSelectedVoice = null;

      // if ('question_audios' in this.props.data && this.props.data.question_audios.length > 0) {
      //   let x = parseInt(Math.random() * 6);

      //   const { question_audios } = this.props.data;
      //   question_audio = `${s3base}/${question_audios[x].value}`;
      //   defaultSelectedVoice = question_audios[x].label;
      // } else {
      //   const { media_link } = this.props.data;
      //   question_audio = `${s3base}${media_link}`;
      // }

      this.selectAndTryAudio();

      var intervalId = setInterval(this.timer, 1000);
      this.setState({
        intervalId: intervalId,
      });
  	}
    navigator.getUserMedia({ audio: true },
      () => {
        console.log('Permission Granted');
        this.setState({ isBlocked: false });
      },
      () => {
        console.log('Permission Denied');
        this.setState({ isBlocked: true })
      },
    );
  }

  // selectAndTryAudio = (startIndex = null) => {
  //     const { question_audios } = this.props.data;
  //     // console.log("I got all the audios >>>>>>>>>>",question_audios);
  
  //     if(!question_audios || question_audios.length === 0) {
  //       const { media_link } = this.props.data;

  //     console.log("media_link==",media_link);
  //       this.setState({
  //       question_audio: `${s3base}${media_link}`,
  //       defaultSelectedVoice: null,
  //       currentAudioIndex: null
  //     });
  //     return
  //     }
  
  //     let audioIndex = startIndex !== null ? startIndex : Math.floor(Math.random() * question_audios.length);
  //     const selectedAudio = question_audios[audioIndex];
  //   this.setState({
  //     question_audio: `${s3base}/${selectedAudio.value}`,
  //     defaultSelectedVoice: selectedAudio.label,
  //     currentAudioIndex: audioIndex
  //   });
  //   }

    selectAndTryAudio = (startIndex = null) => {
    const { question_audios, media_link } = this.props.data;
    // Check if question_audios is empty or undefined
    if (!question_audios || question_audios.length === 0) {
        console.log("No question_audios found, using media_link");
        this.setState({
            question_audio: `${s3base}${media_link}`,
            defaultSelectedVoice: null,
            currentAudioIndex: null
        });
        return;
    }
    
    // If question_audios exist, select one randomly or from startIndex
    let audioIndex = startIndex !== null ? startIndex : Math.floor(Math.random() * question_audios.length);
    const selectedAudio = question_audios[audioIndex];
    
    this.setState({
        question_audio: `${s3base}/${selectedAudio?.value}`,
        defaultSelectedVoice: selectedAudio.label,
        currentAudioIndex: audioIndex
    });
}

    handleAudioError = (errorCode,description) => {
        // console.log("Got the error",errorCode,description)
        const { question_audios ,media_link} = this.props?.data;
      const { currentAudioIndex, audioRetryCount } = this.state;
    
       if (!question_audios || question_audios.length === 0) {
         console.error("No alternative audio available, using media_link");
        this.setState({
            question_audio: `${s3base}${media_link}`,
            defaultSelectedVoice: null,
            currentAudioIndex: null,
            soundKey: this.state.soundKey + 1
        });
        return;
      }

       // If all audios have been tried, fallback to media_link
    if (audioRetryCount >= question_audios.length) {
        console.error("All audios failed, falling back to media_link");
        this.setState({
            question_audio: `${s3base}${media_link}`,
            defaultSelectedVoice: null,
            currentAudioIndex: null,
            soundKey: this.state.soundKey + 1,
            audioRetryCount: 0
        });
        return;
    }

      const nextIndex = (currentAudioIndex + 1) % question_audios.length;
      // console.log(currentAudioIndex,"Curenttttttttttttt")
      // console.log(">>>>>>>>>>>>>>>>>>>>>NEXTTTT",nextIndex);
  //  console.log(`Trying next audio (index ${nextIndex}) ${question_audios[nextIndex].label} after error with index ${currentAudioIndex}`);

   this.setState(
    (prevState) => ({
      audioRetryCount: prevState.audioRetryCount + 1,
      soundKey: prevState.soundKey + 1 // Force Sound component to remount
    }),
    () => {
      
      setTimeout(() => {
        this.selectAndTryAudio(nextIndex);
      }, 100);
    }
  );
  }

  static getDerivedStateFromProps(props, state) {
  	if (props.data) {
  		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
  			clearInterval(state.intervalId);
  			clearInterval(state.recordId);
        // if (this.state.blobURL) {
        //   URL.revokeObjectURL(this.state.blobURL);
        //   this.state.blobURL = "";
        // }
        // this.revokeBlobURL();
        if (state.isRecording) {
        SpeechRecognition.stopListening();
        try {
          Mp3Recorder.stop();
        } catch (e) {
          console.log('Error stopping recorder:', e);
        }
      }

        // let question_audio = null;
        // let defaultSelectedVoice = null;
        // if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        //   let x = parseInt(Math.random() * 6);

        //   const { question_audios } = props.data;
        //   question_audio = `${s3base}/${question_audios[x].value}`;
        //   defaultSelectedVoice = question_audios[x].label;
        // } else {
        //   const { media_link } = props.data;
        //   question_audio = `${s3base}${media_link}`;
        // }
        if (state.blobURL) {
          URL.revokeObjectURL(state.blobURL);
        }

  			return {
          correctFlag: true,
          recordCount: 0,
          isRecording: false,
          secondCount: 3,
          secondCount2: 1,
          questionId: props.data.id,
          blobURL: '',
          reset: true,
          trans: '',
          soundStatus: true,
          duration: 0,
          soundPer : 0,
          question_audio: null,
          defaultSelectedVoice: null,
          currentAudioIndex: null,
          audioRetryCount: 0,
          soundKey: state.soundKey + 1,
          isProcessing: false,
        };
  		}else{
  			if (!state.questionId) {
  				return {correctFlag:true,questionId: props.data.id};
  			}
  		}
  	}
  }


  start = () => {
    this.setState({ beepStatus:true});
  };

  handleBeepFinishedPlaying = () =>{
    if (this.state.isBlocked) {
       if (this.props.soundChecked) {
        this.props.soundChecked();
      }
      return;
    } else {
      SpeechRecognition.startListening({ continuous: true, language: 'en-GB' })
      Mp3Recorder = new MicRecorder({ bitRate: 128 });
      Mp3Recorder
        .start()
        .then(() => {
          this.setState({ isRecording: true,blobURL:'',beepStatus:false});
        }).catch((e) => console.error(e));
    }
  }
  updateCorrect = () =>{
     this.props.submit({'data':''});
     this.setState({correctFlag:false})
  }
  handleSongPlaying = (obj) => {
    this.setState({soundPer:obj.position*100/obj.duration});
  }
  skip = () => {
    clearInterval(this.state.intervalId);
    this.setState({secondCount:0});
  };

  setTrans = (a)=>{
    if (this.state.trans != a) {
      this.setState({trans:a});
    }
    
  }

  stop = () => {
    // Working for Practise,
    if (this.state.isProcessing) return;
    if (!this.props.testMode) {
		this.props.setIsStopped(true)
		}
    if (!this.state.isBlocked && this.state.isRecording) {
      this.setState({isProcessing: true});
      Mp3Recorder
        .stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
         
       
          this.revokeBlobURL();

          if(blob && blob.size > 0){
          // const blobURL = URL.createObjectURL(blob);
          // let duration = await getBlobDuration(blob);
          // let file = new File([blob], 'noname5.mp3', { type: blob.type });
          const duration = await getDuration(blob);
          const file = await getFile(blob, buffer,'noname5.mp3');
          const blobURL = await getBlobURL(blob, file);
          this.setState({ blobURL, 
              isRecording: false,
              recordCount:100,
              file:file,
              duration:duration,
              isProcessing: false
             });
          //   if(this.state.trans && this.state.trans.length > 0) {
          //     const dataToSubmit = {
          //     data: file,
          //     audio_text: this.state.trans,
          //     duration: duration
          //   };
          //   // this.props.submit(dataToSubmit, true);
          //   SpeechRecognition.stopListening();
          // }
          }
          else {
               console.log("We are in the else not recorded");
               this.setState({ isRecording: false,
                recordCount:100, 
                file:null,
                duration:0,
                blobURL: '',
                isProcessing: false
            });
          }
          SpeechRecognition.stopListening();
          //this.props.submit({'data':file },true)
          if(!this.state.isProcessing){
            this.props.submit({
              data: this.state.file,
              audio_text: this.state.trans,
              duration: this.state.duration
            },true);
            this.props.showResult();
          }
        }).catch((e) => console.log(e));
    }else{      
      if(!this.state.isProcessing){
        this.setState({isProcessing: true});
        this.props.submit({
         data: this.state.file,
         audio_text: this.state.trans,
         duration: this.state.duration
       },true);
       this.setState({isProcessing: false});
      }
    }
  };

  stopTest = async () => {
    // Working for Mock Test,
  console.log("stop test called");
    if (this.state.isProcessing) return;
    
    if (!this.state.isBlocked && this.state.isRecording) {
      Mp3Recorder
        .stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          this.revokeBlobURL();
          this.setState({ isProcessing: true });
          if(blob && blob.size > 0){
            // const blobURL = URL.createObjectURL(blob);
            // let duration = await getBlobDuration(blobURL);
            // let file = new File([blob], 'noname5.mp3', { type: blob.type });
            //this.setState({ blobURL, isRecording: false,recordCount:100 });
            const duration = await getDuration(blob);
            const file = await getFile(blob, buffer,'noname5.mp3');
            const blobURL = await getBlobURL(blob, file);            
            this.setState({ 
              file,
              blobURL,
              duration,
              isRecording:false,
              recordCount:100,
              isProcessing: false
            }
          )

          }else{
            this.setState(
            {
              isRecording: false,
              blobURL: "",
              file: null,
              recordCount: 100,
              duration:0,
              isProcessing: false
            }
          );
          }
          SpeechRecognition.stopListening();
        }).catch((e) => {
          console.log("inside stoptest catch");
          this.setState({ isProcessing: false, isRecording: false });
        }
        );
    }else{
      console.log("Short Question : inside stoptest else");
      if(!this.state.isProcessing){
        this.setState({ isProcessing: true });
        this.props.nextQuestion({
          data: this.state.file,
          audio_text: this.state.trans,
          duration: this.state.duration
        });
        this.setState({ isProcessing: false });
      }
    }
  };

	timer = () => {
    if (this.state.secondCount === 0) {
      clearInterval(this.state.intervalId);
      
    }else{
      this.setState({ secondCount: this.state.secondCount -1 });  
    }
    
  }

  timer1 = () => {
    if (this.state.secondCount2 === 0) {
      clearInterval(this.state.intervalId);
      this.start();
      var recordId = setInterval(this.timerRecord, 1000);
      this.setState({'soundStatus':false,recordId: recordId});
    }else{
      if(this.state.secondCount2Bckup === 0) {
        this.setState({secondCount2Bckup: this.state.secondCount2});
      }
      this.setState({ secondCount2: this.state.secondCount2 -1 });  
    }
    
  }

  handleSongFinishedPlaying = () => {
    var intervalId = setInterval(this.timer1, 1000);
    this.setState({'soundStatus':false,intervalId: intervalId});
    // if (this.state.blobURL) {
    //   URL.revokeObjectURL(this.state.blobURL);
    //   this.state.blobURL = "";
    // }
    this.revokeBlobURL();
      this.props.soundChecked();
  } 

  changeRange = (e) => {
      this.setState({volume: e.target.value});
      // console.log(this.state.volume);
  }

	timerRecord = () => {
		if (this.state.recordCount === 8) {
			clearInterval(this.state.recordId);
			// if(this.props.testMode){
      // }
      this.stop();
		}
		this.setState({ recordCount: this.state.recordCount + 1 });	
	}

//   componentDidUpdate(prevProps, prevState) {
//   // If question changed or was reset, select new audio
//   if (this.state.questionId !== prevState.questionId || 
//       (this.state.reset && !prevState.reset)) {
//     this.selectAndTryAudio();
//   }
// }
  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.stopRecording) {
  //     this.stopTest();
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
  // Handle stopRecording from props
  if (this.props.stopRecording) {
    this.stopTest();
  }

  // If question changed or was reset, select new audio
  if (this.state.questionId !== prevState.questionId || 
      (this.state.reset && !prevState.reset)) {
    this.selectAndTryAudio();
  }
}
	componentWillUnmount = () => {
		this.cleanupResources();
	}

  cleanupResources = () => {
    // Clear any running intervals
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
      // console.log("Interval for question countdown cleared.");
    }
    if (this.state.recordId) {
      clearInterval(this.state.recordId);
      // console.log("Interval for recording countdown cleared.");
    }

    // Revoke blob URL if exists
    // if (this.state.blobURL) {
    //   URL.revokeObjectURL(this.state.blobURL);
    // }
    this.revokeBlobURL();

    // Stop speech recognition and recording if active
    if (this.state.isRecording) {
      SpeechRecognition.stopListening();
      // console.log("Stopped speech recognition.");
      if (Mp3Recorder) {
        Mp3Recorder.stop();
        // console.log("Stopped MP3 recorder.");
      }
    }
  };

  changePlaybackSpeed = (speed) => {
    this.setState((prevState) => ({
      soundKey: prevState.soundKey + 1
    }));
    this.setState({playbackSpeed: speed, secondCount2: this.state.secondCount2Bckup});
  }

  changeAudio = (selected) => {
    clearInterval(this.state.intervalId);
    
    this.setState({
      intervalId2: 0
    }, () => {
      
      const { question_audios } = this.props.data;
      const selected_audio = question_audios.filter((audio, i) => {
        return audio.label === selected.label;
      });

      this.setState({
        question_audio: `${s3base}/${selected_audio[0].value}`
      });
    });
  }

  render() {  
    if (this.state.isBlocked) {
      return(<NoMicrophone />);
    }
    // if (this.props.stopRecording) {
    //   this.stopTest();      
    // }
  	let question ="";
    if (this.props.restart) {
      this.props.restartQue();
    }
  	if (this.props.data) {
  		question = this.props.data.question;
      if (this.state.correctFlag) {
        this.updateCorrect();  
      }
  	}
  	if (this.state.reset) {
  		var intervalId = setInterval(this.timer, 1000);
		  this.setState({intervalId: intervalId,reset:false});
  	}
    
    return (
      <>
      <Dictaphone setTrans={this.setTrans} status={this.state.reset || this.state.isRecording} />
      <Col xs={12}>
      	<h4 className="infoText"></h4>
      </Col>
      <Col xs={12}>
      	<div className="col-lg-12 p-0 text-center">
      { !this.props.resultMode && <div>  <div className="currentStatus">
            <p>Current Status:{this.state.soundStatus == true && this.state.secondCount !== 0 && !this.state.isRecording && ' Begining in '+this.state.secondCount+ ' seconds' }
            {this.state.secondCount == 0 && this.state.blobURL === '' && !this.state.isRecording && ' Playing' }
            {(this.state.isRecording || this.state.blobURL !== '') && '  Audio Finished'}
            
            <br></br>
            Volume
             <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100"  />
             <br></br>
            <Progress color="info" value={(this.state.soundPer)} />
            {!this.props.testMode && (
              <div className="d-flex justify-content-between">
                <div className='stop-btn'>
                  {!this.props.testMode && this.state.secondCount!==0 && this.state.blobURL === '' && !this.state.isRecording &&
                    <Button color="success" onClick={this.skip} size="sm">Skip</Button> 
                  }
                </div>
                <div className="stop-btn clearfix">
                  <div className="select-voice pull-left">
                    {this.state.defaultSelectedVoice !== null &&
                      <SelectVoiceDropDown
                        voices={this.props.voices}
                        selected={this.state.defaultSelectedVoice}
                        changeAudio={this.changeAudio}
                      />
                    }
                  </div>
                  <div className="select-speed pull-right">
                    <PlaybackSpeedBtns changePlaybackSpeed={this.changePlaybackSpeed} playbackSpeed={this.state.playbackSpeed} />
                  </div>
                </div>
              </div>
            )}
            </p>
            
          </div>
		  <div className="audio-box">
        <h4>Recorded Answer</h4>
        <p><strong>Current status:</strong></p>
        {/* <p> { this.state.blobURL === '' && this.state.isRecording?"Recording started": '' } </p>
          <p>  { this.state.secondCount == 0 && this.state.secondCount2 !== 0 && 'Recording starts in '+this.state.secondCount2+ ' seconds'  }</p> */}
           <p> {this.state.blobURL === '' && this.state.isRecording ? "Recording started" : ""} </p>

<p> {this.state.blobURL !== '' && !this.state.isRecording ? "Recording finished" : ""} </p>
                  
<p> {this.state.secondCount == 0 && this.state.secondCount2 !== 0 && !this.state.isRecording && 'Recording starts in ' + this.state.secondCount2 + ' seconds'}</p>
        <hr></hr>
        {/*this.state.isRecording && "Recording Time : "+this.state.recordCount*/}
        {!this.props.testMode && this.state.isRecording && <div className='stop-btn'><Button color="success" onClick={this.stop} size="sm">Stop</Button></div>}
        <hr></hr>
        <Progress color="info" value={(this.state.recordCount*12.5)} />
        <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
      </div> </div> }
      <Col xs={12}>
        {!this.props.resultMode && this.props.data && this.state.soundStatus && this.state.secondCount === 0 && <Sound
          url={this.state.question_audio}
          playStatus={Sound.status.PLAYING}
          onFinishedPlaying={this.handleSongFinishedPlaying}
          onPlaying={this.handleSongPlaying}
          volume={this.state.volume}    
          playbackRate={this.state.playbackSpeed}  
          key={this.state.soundKey}  
          onError={this.handleAudioError}  
        />}
      </Col>
		  <Col xs={12}>
		  	{ this.state.blobURL && !this.props.testMode && <audio src={this.state.blobURL} controls="controls" />}
		  </Col>
		</div>
      </Col>      
      <Col xs={12}><h5>{question}</h5></Col> 
      {!this.props.resultMode && this.state.beepStatus && <Sound
                  url={s3base + "/ptedata/ptemedia/beep.mp3"}
                  playStatus={Sound.status.PLAYING}
                  onFinishedPlaying={this.handleBeepFinishedPlaying}
                  onError={(errorCode, description) => {
                    console.error('Beep audio error:', description);
                    this.handleBeepFinishedPlaying();
                    this.setState({ error: 'Beep failed. Starting recording.' });
                  }}
                />}     
      </>
    );
  }
}
export default ShortQue;